const auditTypeEnEnum =
    {
        passed:'passed',
        rejected:'rejected',
        drafted:'drafted',
        submitted:'submitted',
        canceled:'canceled'
    }


export default auditTypeEnEnum;